<template>
  <BaseButton
    variant="toggle"
    :size="size"
    :active="active"
    @click="$emit('click')"
  >
    <slot />
  </BaseButton>
</template>

<script>
import BaseButton from "./BaseButton.vue";

export default {
  name: "ToggleButton",
  components: { BaseButton },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
    },
  },
  emits: ["click"],
};
</script>
